import { PageTitle } from "../components/Headers";
import { PageBody } from "../components/PageBody";
import { Helmet } from "react-helmet-async";
import { DictionaryDefinition } from "../components/DictionaryDefinition";


export const About = () => {
    return (
        <PageBody widthClass="max-w-screen-lg">
            <Helmet>
                <title>About | VizBadger</title>
                <meta
                    name="description"
                    content="Predict and report sports performance using analytics, machine learning and sports modelling."
                ></meta>
                <meta name="keywords" content="Sports models, sports analytics, sports analysis, sports predictions, sports tip, predictive modelling, predictive sports modelling, sports data, sports prediction"></meta>
            </Helmet>

            <div className="px-4 sm:px-6">
                <PageTitle title="About" backLink="/" />

                <div className="mt-8 sm:mt-10 w-full">
                    <DictionaryDefinition />
                </div>
            </div>
        </PageBody>
    );
};
